// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"a3c8dc6f99fe3ced2e97","293":"d021295dd20ff9afb7ca"}[chunkId] + ".js";
};